<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/" class="app-brand demo d-lg-none py-0 mr-4">
      <span class="app-brand-logo demo bg-white">
        <img src="/img/amoslogo.png">
      </span>
      <span class="app-brand-text demo font-weight-normal ml-2">AMOS</span>
    </b-navbar-brand>

    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->
      <hr class="d-lg-none w-100 my-2">

      <b-navbar-nav class="align-items-lg-center">
        <!-- Search -->
        <label class="nav-item navbar-text navbar-search-box p-0 active">
          <i class="ion ion-ios-search navbar-icon align-middle"></i>
          <span class="navbar-search-input pl-2">
            <input type="text" class="form-control navbar-text mx-2" v-model="searchInput" placeholder="Search..." style="width:200px" @keyup.enter="doSearch()">
          </span>
        </label>
      </b-navbar-nav>

      <b-navbar-nav class="align-items-lg-center ml-auto">

        <b-nav-item-dropdown no-caret class="demo-navbar-user">
            <template slot="button-content">
                <span class="btn btn-sm btn-info">
                    Create <i class="fa fa-plus-circle" style="margin-left: 3px;"></i>
                </span>
            </template>

            <b-dropdown-item to="/agencies/create"  v-if="this.$root.hasPermission('agencies.manage')">
                <i class="fa fa-building" style="margin-right: 3px;"></i> Create Agency
            </b-dropdown-item>

            <b-dropdown-item to="/agents/create" v-if="this.$root.hasPermission('agents.manage')">
                <i class="fa fa-users" style="margin-right: 3px;"></i> Create Agent
            </b-dropdown-item>

            <b-dropdown-item to="/carriers/create"  v-if="this.$root.hasPermission('carriers.manage')">
                <i class="fa fa-shield-alt" style="margin-right: 3px;"></i> Create Carrier
            </b-dropdown-item>

            <b-dropdown-item to="/products/create"  v-if="this.$root.hasPermission('products.manage')">
                <i class="fa fa-book" style="margin-right: 3px;"></i> Create Product
            </b-dropdown-item>

            <b-dropdown-item to="/contracts/create"  v-if="this.$root.hasPermission('contracts.manage')">
                <i class="fa fa-wrench" style="margin-right: 3px;"></i> Create Contract
            </b-dropdown-item>

        </b-nav-item-dropdown>

        <b-nav-form v-if="false">
          <b-button variant="success" size="sm" class="my-2 my-sm-0" @click="createEntry()"><i class="fas fa-plus-square"></i> Entry</b-button>
        </b-nav-form>

        <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div>

        <b-nav-item-dropdown right title="Recently Viewed Inspections" @show="possiblyLoadRecent">
          <template slot="button-content">
            <i class="fas fa-eye"></i>
          </template>
          <b-dropdown-item v-if="recentlyViewedLoading">
            Loading <i class="fas fa-spinner fa-spin"></i>
          </b-dropdown-item>
          <template v-else>
            <b-dropdown-item v-on:click="sendTo(item)" v-for="item in recentlyViewed" :key="item.id" :title="`View ${item.record_type}`">

              <i class="fa fa-sm fa-building" v-if="item.record_type == 'Agency'"></i>
              <i class="fa fa-sm fa-users" v-if="item.record_type == 'Agent'"></i>
              <i class="fa fa-sm fa-shield-alt" v-if="item.record_type == 'Carrier'"></i>
              <i class="fa fa-sm fa-address-card" v-if="item.record_type == 'Client'"></i>
              <i class="fa fa-sm fa-file-contract" v-if="item.record_type == 'Policy'"></i>
              <i class="fa fa-sm fa-book" v-if="item.record_type == 'Product'"></i>
              <i class="fa fa-sm fa-wrench" v-if="item.record_type == 'ProductContract'"></i>

              <span v-if="item.record_type === 'Agent' || item.record_type === 'Client'">{{ item.record.first_name }} {{ item.record.last_name }}</span>
              <span v-else-if="item.record_type === 'ProductContract'">{{ item.record && item.record.writing_nbr ? 'Contract '+item.record.id : 'View Contract' }}</span>
              <span v-else>{{ item.record ? item.record[(item.record_type.toLowerCase()) + '_name'] : 'View '+item.record_type }}</span>
            </b-dropdown-item>
          </template>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown :text="user.first_name" right v-if="user">
          <b-dropdown-item v-on:click="sendToRaw('/profile')">
            <i class="fas fa-user"></i> My Profile
          </b-dropdown-item>
          <b-dropdown-item v-on:click="sendToRaw('/comments/read')">
            <i class="fas fa-comments"></i> Read Comments
          </b-dropdown-item>
          <b-dropdown-item v-on:click="sendToRaw('/bug')">
            <i class="fas fa-bug"></i> Submit A Bug
          </b-dropdown-item>
          <b-dd-divider />
          <b-dropdown-item v-on:click="logout()"><i class="fas fa-sign-out-alt text-danger"></i> Log Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  data() {
      return {
          searchInput: null,
          recentlyViewed: [],
          recentlyViewedLoading: false,
      }
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },

    sendTo(item){
      //Build the URL
      var url = '/';

      //Special Cases
      switch(item.record_type)
      {
        case "Agency":
          //Setup
          url += 'agencies';
          break;

        case "Policy":
          //Setup
          url += 'policies';
          break;

        case "ProductContract":
            //Format
            url += 'contracts';
            break;

        default:
          //Pluralize it
          url += item.record_type.toLowerCase() + 's';
          break;
      }

      //Send it
      this.$router.push(url + '/view/'+item.record_id);
    },

    sendToRaw(url){
      this.$router.push(url);
    },

    createEntry(){
      //send it
      this.$router.push('/inspections/create');
    },

    logout(){
      //Remove the Token
      localStorage.removeItem('amos_365_token');

      //Send to the logout helper
      window.location = '/logout';
    },

    doSearch(){
      //Needs at least 2 characters (AMOS-144)
      if(!this.searchInput || this.searchInput.trim().length < 2)
      {
        return;
      }

      //Fire the search or send to the inspections page?
      this.$router.push({path: '/search', query: {q: this.searchInput.trim()}});
    },

    possiblyLoadRecent(){
      //Loading Indicator
      this.recentlyViewedLoading = true;

      //Get it
      this.$http.get('/recently-viewed')
        .then(response => {
            //Set the inspection
            this.recentlyViewed = response.data;
        })
        .catch(error => {

        })
        .then(() => {
          //Reset
          this.recentlyViewedLoading = false;
        });
    },
  }
}
</script>
